import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
}
export function SectionTag({
  children
}: SectionTagProps) {
  return <span className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.14em] text-flame" data-id="element-273" data-mp="fyunl6k57s3m">
      <span className="h-[3px] w-8 bg-flame" aria-hidden="true" data-id="element-274" data-mp="1a6ur81olwhd" />
      {children}
    </span>;
}